import type { BimPriceLevelEnum } from 'gql/graphql';
import { Text, cnMixSpace } from 'uikit';

import { BimPriceLevelBadge } from '../BimPriceLevelChoice';

export const BimModalTitleWithPriceLevel = ({
    modalTitle,
    priceLevel,
}: {
    modalTitle: string;
    priceLevel: BimPriceLevelEnum | undefined;
}) => (
    <div style={{ display: 'flex', alignItems: 'baseline' }}>
        <Text size="s" lineHeight="l" view="secondary" weight="semibold" transform="uppercase">
            {modalTitle}
        </Text>
        {priceLevel && <BimPriceLevelBadge priceLevel={priceLevel} size="l" className={cnMixSpace({ mL: 's' })} />}
    </div>
);

BimModalTitleWithPriceLevel.displayName = 'BimModalTitleWithPriceLevel';
